import { getCurHost } from '~/frontend-shared/helper/util.ts';

export default defineNuxtPlugin((nuxtApp) => {
  const url = useRequestURL();
  const curHost = getCurHost(url.origin) ?? {};
  return {
    provide: {
      curHost
    }
  }
})